import { render, staticRenderFns } from "./QuizFeedbackView.vue?vue&type=template&id=6918a1aa&scoped=true&"
import script from "./QuizFeedbackView.vue?vue&type=script&lang=js&"
export * from "./QuizFeedbackView.vue?vue&type=script&lang=js&"
import style0 from "./QuizFeedbackView.vue?vue&type=style&index=0&id=6918a1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918a1aa",
  null
  
)

export default component.exports